import React from "react"
import styled from "styled-components"

import Layout from "../common/Layout"
import PositionFacts from "./position-facts/PositionFacts"
import OpenPositionsNavBar from "./OpenPositionsNavBar"
import Main from "../common/Main"
import PageIntro from "../common/intro/PageIntro"
import Insights from "./rebase-insights/Insights"

const Container = styled.section`
  margin-inline: auto;
  margin-bottom: 6.6875rem;
  margin-inline: auto;
  max-width: min(79ch, 100% - 2.5rem);
  @media (min-width: 64em) {
    width: min(100% - 2.5rem, 1200px);
    margin-top: 3rem;
    max-width: none;
  }
`

const Wrapper = styled.div`
  display: grid;
  grid-template-areas:
    "sidenavigation"
    "jobcontent";

  @media (min-width: 64em) {
    padding-left: 2.5rem;
    grid-template-columns: 17.625rem 1fr;
    grid-template-areas: "sidenavigation jobcontent";

    width: 100%;
    background: #ffffff;
    box-shadow: rgb(122, 121, 121, 0.2) 0px 0px 0px 1px,
      0px 4px 10px rgba(0, 0, 0, 0.15);

    margin-inline: auto;
  }

  @media (min-width: 64em) {
    padding-left: 5.3125rem;
  }
`

const SideContainer = styled.aside`
  grid-area: sidenavigation;
  position: relative;
  z-index: 99;

  &:before {
    @media (max-width: 64em) {
      content: "";
      position: absolute;
      width: 4px;
      margin-left: -4px;
      height: 100%;
      background-color: var(--clr-secondary-dark);
    }
  }

  margin-top: 3rem;

  @media (min-width: 64em) {
    margin-top: 5.8125rem;
  }
`

const SideCards = styled.div`
  display: none;
  @media (min-width: 64em) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

const Anchor = styled.div`
  scroll-margin-top: 74px;
  @media (min-width: 40em) {
    scroll-margin-top: 70px;
  }
  @media (min-width: 64em) {
    scroll-margin-top: 5.625rem;
  }
`

const PositionLayout = ({ data, children }) => {
  const title = [["Open Positions"]]
  const node = data?.positionMd?.frontmatter

  if (!node) {
    return <div></div>
  }

  const { supervisor, salary, salary_date, rate, rate_date } = node

  return (
    <Layout>
      <Main>
        <PageIntro
          title={title}
          subheading="At Rebase, we're constantly seeking talented and motivated individuals to join our growing team. Browse through our current job listings below, and if you believe you're a great fit for any of these roles, we'd love to hear from you."
        />
        <Container>
          <Wrapper>
            <SideContainer>
              <OpenPositionsNavBar />
              <SideCards>
                <PositionFacts
                  image={data.image}
                  supervisor={supervisor}
                  salary={salary}
                  salaryDate={salary_date}
                  rate={rate}
                  rateDate={rate_date}
                />
                <Insights />
              </SideCards>
            </SideContainer>
            <div>
              <Anchor id="form" />
              {children}
            </div>
          </Wrapper>
        </Container>
      </Main>
    </Layout>
  )
}

export default PositionLayout
